import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {CookieService} from 'ngx-cookie-service';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserAccessGuardService implements CanActivate{

  constructor(
    private auth: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private api: ApiService,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if(this.auth.isSignedInUser())
      return true;
    else {
      console.log(
        window.location.pathname
      )
      window.location.replace('/login'+window.location.pathname)
    }
  }
}
